<template>
  <div>
    <div
      class="col-lg-12"
      style="padding-top: 20px; padding-bottom: 20px"
    ></div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-4">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              INCOMING WASTE CATEGORY
            </p>
            <p style="padding-top: 20px; color: #A5A5A5">Waste Type</p>
            <div style="padding-right: 30px">
              <p
                style="color: #707070; font-weight: 600; font-size: 20px"
              >
                Annex I - Oily bilge water
              </p>
            </div>

            <p style="padding-top: 60px; color: #A5A5A5">Waste Code</p>
            <el-select
              class="select-info tab select-width"
              placeholder="Select"
              v-model="selectedWasteCode"
              style="width: 90%; border-bottom: 1px solid lightgray"
              @change="getType()"
              filterable
            >
              <el-option
                v-for="option in selects.wastecodes"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.value"
              ></el-option>
            </el-select>
            <!-- Button to add selected label -->
            <p style="color: #358CCB" @click="addWaste()">+ Add</p>

            <!-- Display added waste labels -->
            <div v-if="addedLabels.length > 0">
              <div
                style="color: #A5A5A5; display: flex; align-items: center"
                v-for="(label, index) in addedLabels"
                :key="index"
              >
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-2">
                      <p style="color: #A5A5A5; font-weight: 600">
                        {{ index + 1 }}.
                      </p>
                    </div>
                    <div class="col-lg-3">
                      <p style="color: #A5A5A5; font-weight: 600">{{ label }}</p>
                    </div>
                    <div class="col-lg-3">
                      <base-button
                      class="btn-sm btn-cancel"
                    style="font-size: 12px; "
                        @click="removeLabel(index)"
                      >
                        Remove
                    </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-4">
          <card class="card-eprf">
            <div class="col-lg-12">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                GENERATE QR CODE
              </p>
            </div>
            <div style="text-align: center">
              <qrcode-vue :value="value" :size="size" level="L" />
            </div>
            <div
              style="background-color: transparent"
              class="col-lg-12 text-center"
            >
              <base-button type="primary" v-on:click="getBack()"
                >Generate</base-button
              >&nbsp;
              <base-button type="danger" v-on:click="getDone()"
                ><i
                  style="color: white; font-size: 14px; font-weight: 900"
                  class="tim-icons icon-check-2"
                ></i
                >&nbsp; Download</base-button
              >
            </div>

            <div
              style="background-color: transparent"
              class="col-lg-12 text-center"
            >
              <base-button type="primary" v-on:click="getBack()"
                ><i
                  style="color: white; font-size: 14px; font-weight: 900"
                  class="tim-icons icon-check-2"
                ></i
                >&nbsp; Print</base-button
              >
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button type="danger" v-on:click="getBack()">Back</base-button
          >&nbsp;
          <base-button type="primary" v-on:click="getDone()">Done</base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button
            class="btn-link"
            style="color: #052d72; cursor: pointer; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </base-button>
          <!-- <p
            style="cursor: pointer; color: #358CCB; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { Select, Option } from "element-ui";

export default {
  name: "JobPage2",
  components: {
    QrcodeVue,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      selectedFileName: "",
      allfilename: [],

      value: "https://youtube.com/",
      size: 300,
      companyname: "",
      InputData: "",

      selects: {
        wastecode: "1",
        wastecodes: [
          { value: "1", label: "SW 101" },
          { value: "2", label: "SW 102" },
          { value: "3", label: "SW 103" },
          { value: "4", label: "SW 201" },
          { value: "5", label: "SW 202" },
        ],
      },

      selectedWasteCode: "",
      selectedLabel: "",
      addedLabels: [],
    };
  },

  methods: {
    getType() {
      const selectedOption = this.selects.wastecodes.find(
        (option) => option.value === this.selectedWasteCode
      );
      if (selectedOption) {
        this.selectedLabel = selectedOption.label;
      }
    },
    addWaste() {
      if (
        this.selectedLabel &&
        !this.addedLabels.includes(this.selectedLabel)
      ) {
        this.addedLabels.push(this.selectedLabel);
      }
    },
    removeLabel(indexToRemove) {
      this.addedLabels.splice(indexToRemove, 1);
    },
    handleInput(emitEvent, value) {
      this.$emit(emitEvent, value);
    },
    getBack() {
      this.$router.push("/JobPage1");
    },
    getDone() {
      this.$router.push("/Preprocess");
    },
    saveDraft() {
      console.log("save draft");
    },
    onFileChange() {
      this.allfilename.push(this.selects.wastecode[0].label);
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
        this.documentID.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },
  },
};
</script>
<style>
.custom-dropdown .el-select-dropdown {
  /* Dropdown styles */
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-option {
  /* Option styles */
  color: #333;
  background-color: #fff;
}
</style>
